import { ScriptElementSchema } from "@schema-types/types/JourneySchema";
import { ScrollText } from "lucide-react";

export type ScriptElementProps = {
  element: ScriptElementSchema;
};

export const ScriptElement = ({ element }: ScriptElementProps) => {
  const scriptText = element.scriptText?.trim();

  if (!scriptText) {
    return null;
  }

  return (
    <div className="jb-script-element rounded-lg border border-border border-l-4 border-l-primary bg-muted/30 p-4">
      <div className="mb-3 flex items-center gap-2 text-xs font-semibold uppercase tracking-wide text-primary">
        <ScrollText className="h-4 w-4" aria-hidden />
        Script
      </div>
      <p className="whitespace-pre-wrap font-serif text-base leading-relaxed text-foreground">{scriptText}</p>
    </div>
  );
};
